<div class="button-list-container">
  <button
    mat-button
    [disabled]="!instancesReports?.length"
    class="map-top-button"
    [matMenuTriggerFor]="menu"
  >
    <wlm-icon class="vertical-center-icon" icon="reports"></wlm-icon>
  </button>
  <mat-menu #menu="matMenu" class="reports-list-menu">
    <div *ngFor="let instanceReport of instancesReports">
      <div class="map-top-buton-menu-group">
        {{ instanceReport.name }}
      </div>
      <button
        mat-button
        class="material-icons-outlined map-top-button-menu-item"
        *ngFor="let report of instanceReport.reports"
        (click)="selectReport(report, instanceReport.instanceId)"
      >
        {{ report }}
      </button>
    </div>
  </mat-menu>
</div>
